import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { finalize, map, shareReplay, tap } from "rxjs/operators";
import { CityCreated, CityModel, CityService } from "src/app/core/admin";

/**
 * Adds a city that the map geocoded to but the city list lacks. Creations in flight
 * are shared by country and name, so quick repeated clicks — even from different
 * forms — create the city once.
 */
@Injectable({ providedIn: 'root' })
export class GeocodedCityService {
    private _pending = new Map<string, Observable<CityModel>>()

    constructor(
        private _cityService: CityService,
        private _store: Store
    ) {}

    create(name: string, countryId: number): Observable<CityModel> {
        const key = `${countryId}|${name.toLocaleLowerCase()}`
        const pending = this._pending.get(key)
        if (pending) return pending;

        const city = new CityModel()
        city.clear()
        city.name = name
        city.country_id = countryId
        const creation$ = this._cityService.create(city).pipe(
            map(res => res.data as CityModel),
            // Lands in the shared city list, so every dropdown offers it straight away.
            tap(
                created => this._store.dispatch(new CityCreated({ city: created })),
                err => console.error('[geocoded-city] failed to create city', name, err)
            ),
            finalize(() => this._pending.delete(key)),
            shareReplay(1)
        )
        this._pending.set(key, creation$)
        return creation$
    }
}
